

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {

  1: { // Exercise num
    unit: 'Unit 10',
    id: 'SB5-V2-U10-P75-E1', recorder: true,
    audio: 'img/FriendsPlus/Page74/Audio/audio-e2-p70.mp3',
    video: 'img/FriendsPlus/Page74/Videos/e2.p74.mp4',
    component: UI,
    titleQuestion: [{ num: '1', title: ' Listen to the story and repeat. Act.' }],
    exerciseKey: 'img/FriendsPlus/Page71/E2/Key/answerKey.png',
    questionImage: [ // Row      
      [
        // Column2
        { url: 'img/FriendsPlus/Page74/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page74/Audio/hinh1-e2-p70.mp3' },
        { url: 'img/FriendsPlus/Page74/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page74/Audio/hinh2-e2-p70.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page74/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page74/Audio/hinh3-e2-p70.mp3' },
        { url: 'img/FriendsPlus/Page74/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page74/Audio/hinh4-e2-p70.mp3' },
      ],


    ],
  },

  2: { // Exercise num
    unit: 'Unit 10',
    id: 'SB5-V2-U10-P75-E2',
    audio: 'img/FriendsPlus/Page75/Audio/audio-e2-p71.mp3',
    video: '',
    component: D1, recorder: true,
    exerciseKey: '',
    questionImage: [ // Row      
      [
        // Column1
        { url: 'img/FriendsPlus/Page75/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page75/Audio/tieude-e2-p71.mp3' },
        { url: 'img/FriendsPlus/Page75/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page75/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page75/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page75/Audio/doan1.mp3' },
        { url: 'img/FriendsPlus/Page75/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page75/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/9.jpg', audioUrl: 'img/FriendsPlus/Page75/Audio/doan2.mp3' },
        { url: 'img/FriendsPlus/Page75/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page75/E2/11.jpg' },
      ],



    ],
  },
  3: { // Exercise num
    unit: 'Unit 10',
    id: 'SB5-V2-U10-P75-E3',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    textAlign: 'center',
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page75/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page75/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page75/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page75/E3/3.jpg', input: true, answer: "3" },
        { url: 'img/FriendsPlus/Page75/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page75/E3/5.jpg', input: true, answer: "2" },
        { url: 'img/FriendsPlus/Page75/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page75/E3/7.jpg', input: true, answer: "4" },
        { url: 'img/FriendsPlus/Page75/E3/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page75/E3/9.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 10',
    id: 'SB5-V2-U10-P75-E4',
    audio: '',
    video: '',
    padding: '0 0 0 4px',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page75/E4/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page75/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page75/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page75/E4/3.jpg', input: true, answer: "must" },
        { url: 'img/FriendsPlus/Page75/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page75/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page75/E4/6.jpg', input: true, answer: "mustn't" },
        { url: 'img/FriendsPlus/Page75/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page75/E4/8.jpg', input: true, answer: "mustn't" },
        { url: 'img/FriendsPlus/Page75/E4/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page75/E4/10.jpg' },
      ],

    ],
  },
  5: { // Exercise num
    unit: 'Unit 10',
    id: 'SB5-V2-U10-P75-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    questionImage: [ // Row      
      [
        // Column2
        { url: 'img/FriendsPlus/Page75/E5/1.jpg' },
      ]


    ],
  },



}
export default json;
